import { createRoute, Outlet } from '@tanstack/react-router';
import { AppShell } from '@/components';
import { ChangesPoller } from '@/app/ChangesPoller';
import { Route as rootRoute } from './__root';

/**
 * The layout every section renders inside. Pathless: it adds chrome, not a URL segment.
 *
 * Every route file in the product declares this as its parent:
 *
 *   export const Route = createRoute({
 *     getParentRoute: () => shellRoute,
 *     path: '/orders',
 *     component: OrdersPage,
 *   });
 */
function Shell() {
  return (
    <AppShell>
      <ChangesPoller />
      <Outlet />
    </AppShell>
  );
}

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  id: 'shell',
  component: Shell,
});
